import type { UserDto } from '@api/WhisApi/generated/model/userDto';

export type AuthTokens = {
  accessToken?: string;
  refreshToken?: string;
  idToken?: string;
  expiresAt?: number;
  tokenType?: string;
  scope?: string;
};

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export type AuthUserFetchStatus = 'idle' | 'loading' | 'ready' | 'error';

export type AuthUserState = {
  status: AuthUserFetchStatus;
  user: UserDto | null;
  error: Error | null;
};

export type AuthContextValue = {
  status: AuthStatus;
  tokens: AuthTokens | null;
  isAuthenticated: boolean;
  isLoggingIn: boolean;
  isReconnectingSession: boolean;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  user: UserDto | null;
  userFetchStatus: AuthUserFetchStatus;
  userFetchError: Error | null;
  updateUserFetchState: (state: Partial<AuthUserState>) => void;
};

export enum OpenIdScopes {
  /** Required scope for an openId authentication */
  openId = 'openId',

  /** If requested, returns claims that represent basic profile information */
  profile = 'profile',

  /** If requested, returns the email claim */
  email = 'email',

  /** Must be specified to get access token */
  offline_access = 'offline_access',
}
